import React, { useState } from 'react';
import { Box, Card, CardContent, FormControl, InputLabel, MenuItem, Select, Typography } from '@mui/material';
import Upload from '@/AdminComponent/AddVideoForm/Steps/Upload';
import UploadViaAssetId from '@/AdminComponent/AddVideoForm/Steps/UploadViaAssetId';
import { UPLOAD_CHOICES } from '@/AdminComponent/AddVideoForm/constants/uploadChoices';

const VideoUploadSelector = ({ formData, dispatch }) => {
	const [uploadMode, setUploadMode] = useState(UPLOAD_CHOICES.ASSET);

	return (
		<Card sx={{ p: 3, borderRadius: 2, boxShadow: 2 }}>
			<CardContent>
				<Box display="flex" flexDirection="column" gap={3}>
					<Typography variant="h6" fontWeight="600">
						Choose Upload Method
					</Typography>

					<FormControl fullWidth>
						<InputLabel id="upload-mode-label">Upload Method</InputLabel>
						<Select
							labelId="upload-mode-label"
							value={uploadMode}
							label="Upload Method"
							onChange={e => setUploadMode(e.target.value)}
						>
							<MenuItem value={UPLOAD_CHOICES.ASSET}>Upload via Asset ID</MenuItem>
							<MenuItem value={UPLOAD_CHOICES.FILE}>Upload Video</MenuItem>
						</Select>
					</FormControl>
					
					{uploadMode === UPLOAD_CHOICES.FILE && <Upload formData={formData} dispatch={dispatch} />}
					{uploadMode === UPLOAD_CHOICES.ASSET && <UploadViaAssetId dispatch={dispatch} />}
				</Box>
			</CardContent>
		</Card>
	);
};

export default VideoUploadSelector;
